import PropTypes from 'prop-types';
import './input.css';

/**
 * Pain Rating Scale Component (0-10)
 * Visual numeric rating scale with emoji/label mapping
 */
export const PainRatingScale = ({
    label = 'Pain Score',
    name = '',
    value = 0,
    onChange = () => { },
    onBlur = () => { },
    error = '',
    touched = false,
    disabled = false,
    FormGroupClassName = '',
    LabelClassName = '',
}) => {
    const painLevels = [
        { value: 0, label: 'No Pain', emoji: '😊', color: '#28a745' },
        { value: 1, label: 'Minimal', emoji: '🙂', color: '#6c757d' },
        { value: 2, label: 'Mild', emoji: '😐', color: '#17a2b8' },
        { value: 3, label: 'Uncomfortable', emoji: '😕', color: '#ffc107' },
        { value: 4, label: 'Moderate', emoji: '😟', color: '#fd7e14' },
        { value: 5, label: 'Distressing', emoji: '😣', color: '#fd7e14' },
        { value: 6, label: 'Very Distressing', emoji: '😖', color: '#dc3545' },
        { value: 7, label: 'Intense', emoji: '😫', color: '#dc3545' },
        { value: 8, label: 'Very Intense', emoji: '😩', color: '#c82333' },
        { value: 9, label: 'Severe', emoji: '😭', color: '#bd2130' },
        { value: 10, label: 'Unimaginable', emoji: '😱', color: '#a71d2a' },
    ];

    const currentPainLevel = painLevels.find((level) => level.value === Number(value)) || painLevels[0];

    return (
        <div className={`form-group ${FormGroupClassName}`}>
            {label && (
                <label
                    style={{ color: error && touched && 'red' }}
                    className={LabelClassName}
                >
                    {label}
                    {error && <span className="login-danger"> *</span>}
                </label>
            )}

            <div className="pain-rating-container" style={{ marginTop: '10px' }}>
                {/* Visual Display */}
                <div
                    className="pain-display text-center mb-3 p-3"
                    style={{
                        backgroundColor: currentPainLevel.color + '20',
                        borderRadius: '8px',
                        border: `2px solid ${currentPainLevel.color}`,
                    }}
                >
                    <div style={{ fontSize: '48px' }}>{currentPainLevel.emoji}</div>
                    <div style={{ fontSize: '24px', fontWeight: 'bold', color: currentPainLevel.color }}>
                        {value}/10
                    </div>
                    <div style={{ fontSize: '14px', color: '#666' }}>
                        {currentPainLevel.label}
                    </div>
                </div>

                {/* Rating Scale */}
                <div className="pain-scale d-flex justify-content-between align-items-center">
                    {painLevels.map((level) => (
                        <button
                            key={level.value}
                            type="button"
                            className={`btn ${value === level.value ? 'btn-primary' : 'btn-outline-secondary'}`}
                            onClick={() => !disabled && onChange(level.value)}
                            onBlur={onBlur}
                            disabled={disabled}
                            style={{
                                width: '40px',
                                height: '40px',
                                padding: '0',
                                fontSize: '14px',
                                fontWeight: value === level.value ? 'bold' : 'normal',
                                borderRadius: '50%',
                                transition: 'all 0.3s ease',
                            }}
                            title={level.label}
                        >
                            {level.value}
                        </button>
                    ))}
                </div>

                {/* Labels */}
                <div className="d-flex justify-content-between mt-2" style={{ fontSize: '12px', color: '#666' }}>
                    <span>No Pain</span>
                    <span>Unimaginable Pain</span>
                </div>
            </div>

            {error && touched && <div className="text-danger m-1">{error}</div>}
        </div>
    );
};

PainRatingScale.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    error: PropTypes.string,
    touched: PropTypes.bool,
    disabled: PropTypes.bool,
    FormGroupClassName: PropTypes.string,
    LabelClassName: PropTypes.string,
};
